/*
* Broadcast Theme custom.js
*/

(function() {
  console.log('[custom.js] loaded v2');

  const isSmallScreen = () => window.matchMedia('(max-width: 767px)').matches;

  function getVariantNameFromSwatch(swatchLink) {
    // Try common attributes first, then fall back to text
    return (
      swatchLink.getAttribute('data-variant-name') ||
      swatchLink.getAttribute('data-option-name') ||
      swatchLink.getAttribute('aria-label') ||
      swatchLink.textContent ||
      ''
    ).trim();
  }

  function swapVariantImage(card, variantName) {
    if (!variantName) return;

    // Container that holds the variant image divs
    const imagesRoot =
      card.querySelector('[data-product-image]') ||
      card.querySelector('[data-product-image-default]') ||
      card;

    const variantNodes = imagesRoot.querySelectorAll('[data-variant-title]');
    if (!variantNodes.length) {
      // console.log('[custom.js] no [data-variant-title] nodes found');
      return;
    }

    const key = variantName.toLowerCase().trim();
    let matchEl = null;

    // Hide all variant images, find best match
    variantNodes.forEach((node) => {
      const t = (node.getAttribute('data-variant-title') || '')
        .toLowerCase()
        .trim();

      if (!matchEl && (t === key || t.includes(key))) {
        matchEl = node;
      }

      node.classList.remove('is-visible');
      node.style.opacity = '0';
      node.style.visibility = 'hidden';
      node.style.pointerEvents = 'none';
      node.style.position = 'absolute';
      node.style.inset = '0';
      node.style.zIndex = '1';
    });

    // Hide the default figure/img when we have a match
    const defaultFig =
      imagesRoot.querySelector('[data-product-image-default] > figure') ||
      imagesRoot.querySelector('[data-product-image-default] > img');

    if (defaultFig && matchEl) {
      defaultFig.style.opacity = '0';
      defaultFig.style.visibility = 'hidden';
      defaultFig.style.pointerEvents = 'none';
      defaultFig.style.zIndex = '0';
    }

    if (!matchEl) {
      // console.log('[custom.js] no variant node matched for', variantName);
      return;
    }

    // Show selected variant hard
    matchEl.classList.add('is-visible');
    matchEl.style.display = 'block';
    matchEl.style.opacity = '1';
    matchEl.style.visibility = 'visible';
    matchEl.style.pointerEvents = 'auto';
    matchEl.style.position = 'absolute';
    matchEl.style.inset = '0';
    matchEl.style.width = '100%';
    matchEl.style.height = '100%';
    matchEl.style.zIndex = '3';

    console.log('[custom.js] showing variant image for', variantName);
  }

  function swatchHandler(event) {
    if (!isSmallScreen()) return;

    // Variant swatches are anchors with class swatch__link
    const swatchLink = event.target.closest('a.swatch__link');
    if (!swatchLink) return;

    const card = swatchLink.closest('[data-grid-item]');
    if (!card) return;

    const variantName = getVariantNameFromSwatch(swatchLink);
    const variantHref = swatchLink.href || '';

    console.log('[custom.js] SWATCH HIT', {
      variantName,
      variantHref,
    });

    // Stop the PDP navigation
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    // Swap images on the card
    swapVariantImage(card, variantName);

    // Update all product links on the card to go to this variant
    if (variantHref) {
      card.querySelectorAll('[data-product-link]').forEach((link) => {
        link.href = variantHref;
        link.setAttribute('data-product-link', variantHref);
      });
    }
  }

  // Capture clicks/touch on swatches before theme handlers
  ['click', 'touchstart', 'touchend', 'pointerup'].forEach((type) => {
    document.addEventListener(type, swatchHandler, true);
  });
})();

/* Homepage Judge.me count formatting; review data and ratings stay exact. */
(() => {
  if (!document.body.classList.contains('template-index')) return;
  const selector = '[id$="__177490030528095b24"] .jdgm-reviews-count';
  const format = () => {
    document.querySelectorAll(selector).forEach(el => {
      const raw = el.textContent.trim();
      if (!/^[\d,]+$/.test(raw)) return;
      const count = Number(raw.replace(/,/g, ''));
      if (count < 1000) return;
      if (!el.style.getPropertyValue('--rw-review-count-size')) el.style.setProperty('--rw-review-count-size', getComputedStyle(el).fontSize);
      el.setAttribute('data-rw-compact-count', Math.floor(count / 1000) + 'K+');
      el.setAttribute('aria-label', raw + ' reviews');
      el.setAttribute('title', raw + ' reviews');
    });
  };
  const style = document.createElement('style');
  style.textContent = selector + '[data-rw-compact-count]{font-size:0!important}' + selector + '[data-rw-compact-count]::after{content:attr(data-rw-compact-count);font-size:var(--rw-review-count-size)}';
  document.head.appendChild(style);
  document.querySelectorAll(selector).forEach(el => el.style.setProperty('--rw-review-count-size', getComputedStyle(el).fontSize));
  const root = document.querySelector('main');
  if (!root) return;
  let pending = false;
  new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; format(); });
  }).observe(root, {childList:true, subtree:true, characterData:true});
  format();
})();
